import { Flex } from '@styles/flexBox';
import styled, { css } from 'styled-components';

export const SpinnerWrap = styled(Flex)`
  ${(props) =>
    props.centered &&
    css`
      justify-content: center;
      align-items: center;
      height: ${(props) => (props.containerHeight ? props.containerHeight : '100%')};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.isHide &&
    css`
      display: none;
    `}

  ${(props) =>
    props.absoluteCenter &&
    css`
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 100;
    `}
`;
